import React from 'react';
import * as Icons from '../iconList/svgIcons';
export var Icon = function Icon(_ref) {
  var src = _ref.src;
  var iconSrc = src;
  var renderedIcon = Icons[iconSrc];

  if (!renderedIcon) {
    renderedIcon = Icons.help;
    iconSrc = 'help';
    console.warn("Icon \"".concat(src, "\" is not recognized."));
  }

  return React.createElement(React.Fragment, null, React.cloneElement(renderedIcon, {
    key: iconSrc
  }));
};